import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import AkunCategory from "views/admin/config/akunCategory/AkunCategory";
import AkunSubCategory from "views/admin/config/akunSubCategory/AkunSubCategory";
import AkunSubChildCategory from "views/admin/config/akunSubChildCategory/AkunSubChildCategory";
import AssetKategori from "views/admin/config/assetKategori/AssetKategori";
import BidangUsaha from "views/admin/config/bidangUsaha/BidangUsaha";
import PelangganJenis from "views/admin/config/pelangganJenis/PelangganJenis";
import User from "views/admin/config/user/User";
import BackupData from "views/admin/config/backupData/BackupData";

export default function MasterData() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
          <Switch>
            <Route path="/config/AkunCategory" exact component={AkunCategory} />
            <Route
              path="/config/AkunSubCategory"
              exact
              component={AkunSubCategory}
            />
            <Route
              path="/config/AkunSubChildCategory"
              exact
              component={AkunSubChildCategory}
            />
            <Route
              path="/config/AssetKategori"
              exact
              component={AssetKategori}
            />
            <Route path="/config/BidangUsaha" exact component={BidangUsaha} />
            <Route
              path="/config/PelangganJenis"
              exact
              component={PelangganJenis}
            />
            <Route path="/config/User" exact component={User} />
            <Route path="/config/Backup" exact component={BackupData} />
            <Redirect from="/config/*" to="/config/akunCategory" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
